import React, { useState, useEffect } from 'react';
import axios from "../../../network/index";
import { Box, Button, MenuItem, Select, Stack, Typography } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { CLOSE, SUBMIT, WANT_TO_REJECT } from "../../../constants/string";
import theme from '../../../CustomTheme';

const CommentBox = ({handleRejectOnSubmit, handleClose }) => {
  const [reasons, setReasons] = useState([]);
  const [selectedReason, setSelectedReason] = useState({id:'', name:''}); 
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    axios
      .get("/reasons/getreasons/reject_order")
      .then((data) => {
        if (data.data?.Result) {
          const reasonArray = Object.entries(data.data.data).map(([id, name]) => ({
            id,
            name,
          }));
          setReasons(reasonArray);
        } else {
          setIsError(true);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching reasons:', error);
        setIsLoading(false);
        setIsError(true);
      });
  }, []);

  const handleReasonId = (e) => {
    setSelectedReason(e.target.value);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    handleRejectOnSubmit(selectedReason);
    handleClose();
  }
  return (
  <Box style={styles.container}>
    <Box style={styles.titleBar}>
      <Typography sx={{fontWeight:'bold',marginLeft: "10px" }} >{WANT_TO_REJECT}</Typography> 
      <Button onClick={handleClose} style={{...styles.closeButton, paddingRight: ".1px"}} >
        <HighlightOffIcon style = {{color: 'black'}}/>
      </Button>
    </Box>
    <Stack>
      <Box>
        <span style={styles.label} htmlFor="reason">Select Reason:</span>
        <Box className="box">
          <Select
           id="reason"
           value={selectedReason.name}
           onChange={handleReasonId}
           displayEmpty
           renderValue={(value) => (value ? value : "Select a reason")}
           required
           style={{...styles.input, height: '40px', textAlign: 'left',}}
          >
            {reasons.map((reason) => (
              <MenuItem key={reason.id} value={reason}>{reason.name}</MenuItem>
            ))}
          </Select>
        </Box>
      </Box>

      <Stack spacing={2} direction="row" sx={{ display: "flex", alignItems: "center", justifyContent: "center", }}>
        <Button onClick={handleClose} style={{ ...styles.button, background: 'lightgray',color: 'black' }}>
          {CLOSE}
        </Button>
        <Button type="submit" onClick={handleOnSubmit}  style={styles.button}>
          {SUBMIT}
        </Button>
      </Stack>
    </Stack>
  </Box>
  );
};

const styles = {
  container: {
    maxWidth: '400px',
    margin: '20px auto',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    border: '1px solid #ddd',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  },
  titleBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'lightgray',
    padding: '2px',
    borderRadius: '5px 5px 0 0',
    borderBottom: '1px solid #ddd',
    color: 'black',
    fontWeight: 'bold',
    fontSize: '16px',
    
  },
  closeButton: {
    backgroundColor: 'transparent',
    border: 'none',
    fontSize: '25px',
    cursor: 'pointer',
  },
  label: {
    display: 'block',
    marginBottom: '8px',
    fontWeight: 'bold',
    color: 'black',
    textAlign: 'left',
    fontSize: '16px',
    marginTop: '16px',
  },
  input: {
    width: '100%',
    borderRadius: '5px',
    border: '1px solid #ccc',
    marginBottom: '15px',
    fontSize: '16px',
  },
  textarea: {
    width: '100%',
    borderRadius: '10px',
    border: '1px solid #ccc',
    marginBottom: '15px',
    fontSize: '16px',
    height: '100px',
    resize: 'none',
  },
  button: {
    padding: '5px',
    backgroundColor: theme.palette.primary.main,
    border: 'none',
    borderRadius: '5px',
    color: 'white',
    fontSize: '16px',
    cursor: 'pointer',
    width: '100px',
    display: 'block',
    textTransform: 'none',
  },
};

export default CommentBox;
